import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EbClaimHistoryService } from '../../../services/eb-claim-history/eb-claim-history.service';
import { EBClaimStatusVm } from '../../../models/eb-claim-status-vm';

@Component({
  selector: 'app-dialog-eb-claim-details',
  templateUrl: './dialog-eb-claim-details.component.html',
  styleUrls: ['./dialog-eb-claim-details.component.scss']
})
export class DialogEbClaimDetailsComponent  implements OnInit {

  claimStatusList : EBClaimStatusVm[] = [];
  selectedTab = 0;
  tabs = [
    {
      index: 0,
      name: "Status Details",
    },
    {
      index: 1,
      name: "Submitted Documents",
    },
    {
      index: 2,
      name: "Explanation Of Benefits",
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogEbClaimDetailsComponent>,
    private ebClaimHistoryService: EbClaimHistoryService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getClaimStatusByClaimEntryId(data.claimEntryId)
  }

  ngOnInit() {}

  getClaimStatusByClaimEntryId(claimEntryId: number){
    this.ebClaimHistoryService.getClaimStatusDetails(claimEntryId).subscribe(
      (res : EBClaimStatusVm[]) => {
        this.claimStatusList = res;
      }
    )
  }

  onTabClick(index){
    this.selectedTab = index;
  }

  onCancel() {
    this.dialogRef.close('no');
  }
}

